export default {
  year: 2024,
  contests: [
    {
      title: "2024 ICPC Asia Seoul Regional Contest",
      columns: ["#", "=", "팀", "멤버"],
      data: [
        ["13", "7", "AllTimeLegend", "박성준, 송근수, 이승형"],
        ["18", "7", "Redshift", "박수현, 조원빈, 채성우"],
        ["71", "3", "0x200", "김형은, 심진희, 이재찬"],
      ],
      award: ["advanced", "advanced", ""],
      links: [
        ["공식 사이트", "http://icpckorea.org/2024-seoul/regional"],
        ["스코어보드", "http://static.icpckorea.net/2024/regional/scoreboard"],
      ],
      review: [],
    },
    {
      title: "2024 ICPC Asia Seoul Preliminary Contest",
      columns: ["#", "=", "팀", "멤버"],
      data: [
        ["15", "6", "AllTimeLegend", "박성준, 송근수, 이승형"],
        ["22", "5", "Redshift", "박수현, 조원빈, 채성우"],
        ["58", "4", "0x200", "김형은, 심진희, 이재찬"],
        ["80", "3", "goraani", "강효규, 김동건, 유호영"],
        ["90", "3", "I2C", "김진수, 박준성, 하건영"],
        ["98", "3", "YellowMinions", "김서인, 이민희, 정재헌"],
        ["199", "1", "ChoParkPark", "박정원, 박준영, 조다니엘"],
        ["201", "1", "Hyuntaegod", "정현태, 유승훈, 이준우"],
        ["226", "1", "TLEMECHANIC", "송태호, 이승찬, 정유연"],
        ["269", "1", "Wannerbee", "김태윤, 김홍래, 도하준"],
      ],
      award: ["advanced", "advanced", "advanced", "", "",
              "", "", "", "", ""],
      links: [
        ["공식 사이트", "http://icpckorea.org/2024-seoul/regional"],
        [
          "스코어보드",
          "http://static.icpckorea.net/2024/first_round/scoreboard_10282200/",
        ],
      ],
      review: [],
    },
    {
      title: "LG Collegiate Programming Contest 2024",
      columns: ["#", "이름"],
      data: [
        ["4", "송근수"],
        ["4", "이승형"],
        ["5", "박성준"],
        ["-", "조원빈"]
      ],
      award: [""],
      links: [
        ["공식 사이트", "https://www.lgsdc.com/registration/programming-contest/"],
      ],
      review: [],
    },
    {
      title: "Samsung Collegiate Programming Contest 2024 Finals",
      columns: ["#", "이름"],
      data: [
        ["4", "박수현"],
        ["5", "강효규"],
        ["5", "박성준"],
        ["-", "김동건"],
        ["-", "조원빈"],
        ["-", "송근수"],
        ["-", "채성우"]
      ],
      award: [""],
      links: [
        ["공식 사이트", "https://www.codeground.org/scpc/commons/honer/list"],
      ],
      review: [],
    },
    {
      title: "SUAPC 2024 Summer",
      columns: ["#", "=", "팀", "멤버"],
      data: [
        ["2", "12", "Redshift", "박수현, 조원빈, 채성우"],
        ["5", "9", "ALL_TIME_LEGEND", "박성준, 송근수, 이승형"],
        ["6", "9", "goraani never stop", "강효규, 김동건, 유호영"],
        ["9", "6", "I2C", "김진수, 박준성, 하건영"],
        ["10", "6", "팀 이름", "손기령, 정회윤, 조성훈"]
      ],
      award: ["silver", "bronze", "bronze", "", ""],
      links: [
        ["공식 사이트", "https://icpc-sinchon.io/suapc"],
        ["스코어보드", "https://www.acmicpc.net/contest/spotboard/1319"],
      ],
      review: [
        ["채성우(lem0nad3)", "https://blog.naver.com/vermeil_/223568417158"],
      ],
    },
    {
      title: "UCPC 2024 본선",
      columns: ["#", "=", "팀", "멤버"],
      data: [
        ["4", "10", "개척단 훈련소", "박수현, 강혜아(RUN), 최은수(RUN)"],
        ["15", "8", "Some_Time_Legend", "송근수, 이승형, 조원빈"],
        [
          "39",
          "5",
          "일단팀명에조민수를넣고민수가좋아하는블루아카도넣으면되겠는데",
          "박성준, 채성우, 박용한(SSU)",
        ],
        ["42", "5", "goraani never stop", "김동건, 강효규, 유호영"],
      ],
      award: ["bronze", "special", "", ""],
      links: [
        ["공식 사이트", "https://ucpc.me/"],
        ["스코어보드", "https://www.acmicpc.net/contest/spotboard/1316"],
      ],
      review: [
        ["채성우(lem0nad3)", "https://blog.naver.com/vermeil_/223540305208"],
      ],
    },
    {
      title: "24년 현대모비스 알고리즘 경진대회(학생부)",
      columns: ["#", "이름"],
      data: [["우수상", "조원빈"],
             ["-", "송근수"]],
      award: ["", ""],
      links: [
        ["공식 사이트", "https://career.programmers.co.kr/competitions/3980"],
      ],
      review: [],
    },
    {
      title: "2024 ICPC Asia Pacific Championship",
      columns: ["#", "=", "팀", "멤버"],
      data: [
        ["37", "5", "Redshift", "박수현, 이준석, 채성우"],
        ["42", "5", "Raa FanClub", "박성준, 송근수, 이승형"],
      ],
      award: ["", ""],
      links: [
        ["공식 사이트", "https://icpc.asia"],
        ["스코어보드", "https://icpcasia.firebaseapp.com/standings"],
      ],
      review: [
        ["채성우(lem0nad3)", "https://blog.naver.com/vermeil_/223371572976"],
      ],
    },
    {
      title: "SUAPC 2024 Winter",
      columns: ["#", "=", "팀", "멤버"],
      data: [
        ["2", "9", "goraani", "강효규, 김동건, 조원빈"],
        ["3", "9", "Raa FanClub", "박성준, 송근수, 이승형"],
        ["9", "8", "기령손", "김서인, 손기령, 이하윤"],
      ],
      award: ["silver", "silver", ""],
      links: [
        ["공식 사이트", "https://icpc-sinchon.io/suapc"],
        ["스코어보드", "https://www.acmicpc.net/contest/spotboard/1237"],
      ],
      review: [
        ["김동건(dong_gas)", "https://blog.naver.com/dong_gas/223358906873"],
      ],
    },
    {
      title: "solved.ac Grand Arena Party × NEXON - Div 2",
      columns: ["#", "=", "이름"],
      data: [["13", "4", "정회윤"]],
      award: [""],
      links: [],
      review: [["정회윤(yunny_world)", "https://yunny-world.tistory.com/87"]],
    },
  ],
};
